import { Box, Stack, Typography, Divider, Link, Grid } from "@mui/material";
import { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import { themeColors } from "../styles/theme";
import {
    Instagram as InstagramIcon,
    Facebook as FacebookIcon,
    Twitter as TwitterIcon,
} from '@mui/icons-material';
// Import logo
import suntapLogo from '../img/suntap_logo.svg';

export const SocialIcons: FC = () => {
    return (
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{ mb: 4 }}>
            <InstagramIcon sx={{ color: 'black', fontSize: '40px' }} />
            <FacebookIcon sx={{ color: 'black', fontSize: '40px' }} />
            <TwitterIcon sx={{ color: 'black', fontSize: '40px' }} />
        </Stack>
    );
};

export const Footer: FC = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <Box sx={{ 
            width: '100%', 
            justifyContent: 'left',
            mt: 4,
            pb: 3
        }}>
            {/*I included these as they are in the designs, but have commented out until we actually want / have them*/}
            {/*<SocialIcons />*/}
            
            {/* Suntap Logo */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                <img
                    src={suntapLogo}
                    alt="Suntap Logo"
                    style={{
                        height: '50px',
                    }}
                />
            </Box>
            
            <Divider sx={{ my: 2, borderColor: 'rgba(0, 0, 0, 0.1)' }} />
            
            {/* Google Maps Attribution Section - Required by Google ToS */}
            <Box sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <img 
                        src={require("../img/google_logo/desktop/google_on_white.png")} 
                        alt="Google" 
                        height="24" 
                        width="auto"
                    />
                    <Typography variant="body2" sx={{ fontFamily: "Roboto, sans-serif", fontSize: '14px' }}>
                        Map data ©{currentYear} Google
                    </Typography>
                </Box>
                
                <Typography variant="body2" sx={{ fontFamily: "Roboto, sans-serif", fontSize: '14px', mb: 1 }}>
                    This application includes Google Maps features and content. Use of Google Maps features and content is subject to the&nbsp;
                    <Link 
                        href="https://maps.google.com/help/terms_maps/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        sx={{ color: themeColors.blue }}
                    >
                        Google Maps/Google Earth Additional Terms of Service
                    </Link>
                    &nbsp;and the&nbsp;
                    <Link 
                        href="https://policies.google.com/privacy" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        sx={{ color: themeColors.blue }}
                    >
                        Google Privacy Policy
                    </Link>.
                </Typography>
            </Box>
            
            {/* Quick Links */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={6} sm={3}>
                    <Link 
                        component={RouterLink} 
                        to="/about"
                        sx={{ 
                            fontFamily: "DM Sans, sans-serif", 
                            color: 'black', 
                            textDecoration: 'none',
                            '&:hover': { textDecoration: 'underline' }
                        }}
                    >
                        About & FAQ
                    </Link>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Link 
                        component={RouterLink} 
                        to="/submit"
                        sx={{ 
                            fontFamily: "DM Sans, sans-serif", 
                            color: 'black', 
                            textDecoration: 'none',
                            '&:hover': { textDecoration: 'underline' }
                        }}
                    >
                        Submit a Garden
                    </Link>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Link 
                        component={RouterLink} 
                        to="/privacy-policy"
                        sx={{ 
                            fontFamily: "DM Sans, sans-serif", 
                            color: 'black', 
                            textDecoration: 'none',
                            '&:hover': { textDecoration: 'underline' }
                        }}
                    >
                        Privacy Policy
                    </Link>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Link 
                        component={RouterLink} 
                        to="/terms-of-use"
                        sx={{ 
                            fontFamily: "DM Sans, sans-serif", 
                            color: 'black', 
                            textDecoration: 'none',
                            '&:hover': { textDecoration: 'underline' }
                        }}
                    >
                        Terms of Use
                    </Link>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Link 
                        href="mailto:hello@sun-tap.com"
                        sx={{ 
                            fontFamily: "DM Sans, sans-serif", 
                            color: 'black', 
                            textDecoration: 'none',
                            '&:hover': { textDecoration: 'underline' }
                        }}
                    >
                        hello@sun-tap.com
                    </Link>
                </Grid>
            </Grid>
            
            {/* Copyright */}
            <Typography 
                variant="body2" 
                sx={{ 
                    fontFamily: "DM Sans, sans-serif", 
                    fontSize: '14px',
                    color: 'rgba(0, 0, 0, 0.6)'
                }}
            >
                © {currentYear} Suntap. All rights reserved.
            </Typography>
        </Box>
    );
};

export default Footer;